var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconElitePricing = function SvgIconElitePricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-elite-pricing_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "url(#icon-elite-pricing_svg__b)",
    rx: 18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-elite-pricing_svg__c)",
    fillOpacity: 0.6,
    d: "M62.589-3.165c3.057 1.778 8.007 11.95 10.1 16.813L51.509 97.81c-10.437-3.453-31.76-17.954-33.554-48.33C16.162 19.102 32.112-2.012 40.312-8.772c6.151 1.128 19.22 3.828 22.277 5.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35.175 26.833 30 47.667l-5.175-20.834h10.35Zm-6.602-12.501-3.535 9.723h9.923l-3.535-9.723h-2.853Zm9.344 9.723h8.53a4.127 4.127 0 0 0-.556-1.111l-4.904-6.866a4.167 4.167 0 0 0-3.39-1.746h-3.215l3.535 9.723Zm.118 2.778-3.84 15.695 11.582-14.584c.26-.337.467-.711.612-1.111h-8.354Zm-16.07 0H13.61c.148.4.357.774.618 1.11l11.577 14.585-3.84-15.695Zm.118-2.778 3.535-9.723h-3.214a4.167 4.167 0 0 0-3.39 1.746l-4.905 6.866c-.24.34-.428.714-.556 1.11h8.53Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-elite-pricing_svg__b",
    x1: 23.782,
    x2: 36.821,
    y1: 20.845,
    y2: 71.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97C53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-elite-pricing_svg__c",
    x1: 60.531,
    x2: 22.45,
    y1: -4.24,
    y2: 62.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF6D7",
    stopOpacity: 0.33
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-elite-pricing_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#fff",
    rx: 18
  })))));
};
export default SvgIconElitePricing;